/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ModelUtils } from '../util/ModelUtils';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { ChangePropertyCommand } from './ChangePropertyCommand';

/**
 * A command used to modify the simple property of a node.  Should not be used
 * to modify complex (object) properties, only simple property types like
 * string, boolean, number, etc.  This differs from {@link ChangePropertyCommand}
 * in that it can be constructed from a {@link NodePath} rather than a {@link Node}
 * and therefore can be used in {@link AggregateCommand} use-cases where there is
 * a Create followed by a SetProperty.
 * 
 * @author eric.wittmann@gmail.com
 * @extends ChangePropertyCommand
 * @class
 */
export class SetPropertyCommand<T> extends ChangePropertyCommand<T> {
    public constructor(nodePath? : any, property? : any, newValue? : any) {
        if(((nodePath != null && nodePath instanceof <any>NodePath) || nodePath === null) && ((typeof property === 'string') || property === null) && ((newValue != null) || newValue === null)) {
            let __args = arguments;
            super();
            (() => {
                if(ModelUtils.isDefined(nodePath)) {
                    this._nodePath = nodePath;
                }
                this._property = property;
                this._newValue = newValue;
            })();
        } else if(nodePath === undefined && property === undefined && newValue === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }
}
SetPropertyCommand["__class"] = "io.apicurio.datamodels.cmd.commands.SetPropertyCommand";
SetPropertyCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




